seedWebApp.controller('IndexDicsCtrl', ['$scope', '$routeParams', '$location', '$window',
    function ($scope, $routeParams, $location, $window) {

        $scope.defaultPages = [                    
            { pageIndex: 0, pageLabel: 'Dicionário Dados', pageDisplay: 'Dics/Dics', pageUrl: 'SPA/dics/dics.html' },
            { pageIndex: 1, pageLabel: 'Colunas', pageDisplay: 'Dics/Dics', pageUrl: 'SPA/dics/dicCols.html' },
            //{ pageIndex: 2, pageLabel: 'Integrações', pageDisplay: 'Dics/Dics', pageUrl: 'SPA/dics/dicIntegrations.html' },            
        ];

        $scope.loadingTabs = true;
        $scope.selTab = $routeParams.Tab;

        $scope.tabSelected = function (page) {
            $location.search('Tab', page.pageIndex);
            $scope.selectedIndex = page.pageIndex;
        };

        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize();
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

        $scope.$watch('modules', function () {
            if ($scope.modules) {
                $scope.verifyPermsAndDefineTabs($scope, 'Dics');
            }
        });
    }
]);